import $dataStr from 'fxdom/es/dataStr.js';
import { html, strMap } from 'fxjs/es';
import { MpShopProductTmplS } from '../../../MpShop/Product/S/Tmpl/module/MpShopProductTmplS.js';
import { MShopStudioPcInfoTmplS } from '../../../MShop/Studio/PcInfo/S/Tmpl/module/MShopStudioPcInfoTmplS.js';
import { UtilS } from '../../../Util/S/Function/module/UtilS.js';
import { messages } from '../../Setting/S/messages_id.js';
import { makeStoreLayoutHtml } from '../../StoreLayout/S/tmpl.js';
import { StudioHeader } from '../../../../services/MarppleShop/marppleShopStudioApp/components/cells/Layout/StudioTitle.ts';
import { classes } from '@services/MarppleShop/shared/util/index.ts';
import { font } from '@services/MarppleShop/shared/typography/index.ts';
import { ECateRootId } from '@services/MarppleShop/shared/enum/ECateRootId.ts';

const display_names_by_cate_root_id = {
  [ECateRootId.Goods]: ET('settings_arrangement::goods'),
  [ECateRootId.Handmade]: ET('settings_arrangement::handmade'),
  [ECateRootId.BrandDeal]: ET('settings_arrangement::brand_deal'),
  [ECateRootId.Ebook]: ET('settings_arrangement::ebook'),
};

export const makeSortableProductItemsHtml = (store_products) =>
  strMap(
    (sp) => `<div class="product_item" data-place_idx="${
      UtilS.is_number(sp.place_idx) ? sp.place_idx : ''
    }" data-sp_id="${sp.sp_id}">
        <i class="d-block lnr lnr-checkmark-circle selected_mark"></i>
        ${MpShopProductTmplS.item('arrangement')(sp)}
      </div>`,
    store_products,
  );

export const makeArrangementSettingsBodyHtml = ({
  store,
  user,
  pagination_state,
  store_products,
  has_banner = !!store.banner_img,
  is_mobile,
  cate_root_ids,
  selected_cate_root_id,
}) =>
  is_mobile
    ? html`<div class="no_mobile">
        ${MShopStudioPcInfoTmplS.unsupportedMobile(T(messages.arrangement.only_pc))}
      </div>`
    : html`
        <div class="header flex">
          <div class="left">
            ${new StudioHeader({
              title: UtilS.isMarppleShopApp()
                ? ET('mps2::studio::page::store_product_arrangement')
                : T(messages.menus.arrangement),
              description: UtilS.isMarppleShopApp()
                ? ET('mps2::studio::page::store_product_arrangement_guide')
                : T.lang === 'kr'
                  ? T(messages.arrangement.desc)
                  : undefined,
              with_margin: false,
            }).toHtml()}
          </div>
          <div class="right">
            <button class="btn btn-save">${T(messages.arrangement.save)}</button>
          </div>
        </div>

        <nav>
          <ul class="setting_arrangement_tab_list">
            ${strMap((cate_root_id) => {
              return html`<li>
                <a
                  class="${classes('tab', font('14_medium'), {
                    tab_selected: cate_root_id === selected_cate_root_id,
                  })}"
                  href="${`/${T.lang}/${UtilS.escape(store.domain_name)}/settings/arrangement?cate_root_id=${cate_root_id}`}"
                >
                  ${display_names_by_cate_root_id[cate_root_id]}
                </a>
              </li>`;
            }, cate_root_ids)}
          </ul>
        </nav>

        <div class="arrangement_container body" data-fx-json="${$dataStr(pagination_state)}">
          <div class="arrangement_body">
            <div class="store_container">
              <div class="header">
                <span class="${classes('page_title', font('16_bold'))}"
                  >${ET('settings_arrangement::page_title')}</span
                >

                <span class="${classes('description', font('12_medium'))}"
                  >${ET('settings_arrangement::description')}</span
                >
              </div>

              <div class="store_preview">
                ${makeStoreLayoutHtml({
                  locals: { store, login_user: user, has_banner, draw_header: false },
                  body: ``,
                })}
                <div class="store-products">${makeSortableProductItemsHtml(store_products)}</div>
              </div>
            </div>
            <div class="clipboard_container" data-open="true">
              <div class="clipboard">
                <div class="header">
                  <p class="title">${T('클립보드')}</p>
                </div>
                <div class="clipboard-guide">
                  <img
                    src="//s3.marpple.co/files/u_1504988/2021/3/original/68b53ce913b4672ecb154e38460e3a13f4db13d21.png"
                    alt="드래그 아이콘"
                  />
                  <p>${T(messages.arrangement.desc2)}</p>
                </div>
              </div>
              <div class="drop_area"></div>
            </div>
            <button class="open_btn" data-open="true" type="button">
              <i class="d-block lnr lnr-chevron-left will-open"></i>
              <i class="d-block lnr lnr-cross will-close"></i>
            </button>
          </div>
        </div>
        <div class="infinite_scroll_target"></div>
      `;
